<template>
	<div class="dynvibeBox dynvibeSearch" style="min-height: 10px">
		<div class="col-lg-12 dynvibeTitleBox">
			<h2>Create trend</h2>
		</div>
		<div class="dynvibeRow" id="dynvibeSearchFiltersBase">
			<h5>Mastertag</h5>
			<div class="col-md-6" style="padding-left: 0">
				<input :value="mastertag" class="form-control dynvibeSearchInputSearch" />
			</div>
			<div class="col-md-2"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: "createtrend",
	props: {
		mastertag: String,
	},
};
</script>

<style scoped>
.dynvibeModalAdvancedSearchField {
	padding: 0;
	border-top: none;
}
.dynvibeSearchInputSearch {
}
</style>
